<template>
  <div class="zsca-choujiang">
    <div class="button" @click="handleChoujiang"></div>
    <!-- 立即抽奖 -->
    <ElDialog
      :visible.sync="visibleDraw"
      width="808px"
      custom-class="el-dialog-clearstyle-class custom-class-draw"
      append-to-body
    >
      <div class="rule-record-container">
        <div class="lihui">
          <img src="@/assets/zs_imgs/cj-lihui.png" />
        </div>
        <div class="main">
          <div class="header">
            <div class="title"></div>
            <div class="menu">
              <div class="jiangbei" @click="visibleRecord = true">中奖名单</div>
              <div class="rule" @click="visibleRule = true">抽奖规则</div>
            </div>
          </div>
          <div class="body body-draw">
            <div class="title">
              <div class="toyou">送你648！</div>
              <div class="wiki">WIKI二周年抽奖活动</div>
            </div>
            <div class="time">{{ time }}</div>
            <div class="fuli">
              <div class="new">
                <div class="inner">
                  <div class="name">新粉福利</div>
                  <div class="desc">关注账号，立抢红包</div>
                  <div class="container">
                    <div class="item">
                      <div class="item-inner">
                        <div class="txt">激情抽爆</div>
                        <img src="@/assets/zs_imgs/cj-draw-10.png" class="icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="old">
                <div class="inner">
                  <div class="name">老粉福利</div>
                  <div class="desc">粉丝列表中抽取，最高5次中奖机会</div>
                  <div class="container">
                    <div class="item">
                      <div class="item-inner">
                        <div class="txt">每日抽取</div>
                        <img src="@/assets/zs_imgs/cj-draw-card.png" class="icon" />
                      </div>
                    </div>
                    <div class="item">
                      <div class="item-inner">
                        <div class="txt">21号 22号抽取</div>
                        <img src="@/assets/zs_imgs/cj-draw-648.png" class="icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div class="fllow">
              <div>每关注1个账号赠1次抽奖机会</div>
              <a :href="douyinLink" target="_blank">
                <div class="plat douyin" @click="handleJumpMedia('douyin')">
                  <span>前往</span>
                </div>
              </a>
              <a :href="wechatLink" target="_blank">
                <div class="plat wechat" @click="handleJumpMedia('weixin')">
                  <span>前往</span>
                </div>
              </a>
              <a :href="bilibiliLink" target="_blank">
                <div class="plat bilibili" @click="handleJumpMedia('bilibili')">
                  <span>前往</span>
                </div>
              </a>
            </div>
          </div>
          <div class="draw-button draw-button-disable" @click="handleDraw">活动已结束</div>
        </div>
      </div>
    </ElDialog>
    <!-- 奖励规则  -->
    <ElDialog
      :visible.sync="visibleRule"
      width="808px"
      custom-class="el-dialog-clearstyle-class custom-class-rule"
      append-to-body
      @opened="onRuleOpened"
    >
      <div class="rule-record-container">
        <div class="lihui">
          <img src="@/assets/zs_imgs/cj-lihui.png" />
        </div>
        <div class="main">
          <div class="header">
            <div class="title">奖励规则</div>
            <div class="menu">
              <div class="back" @click="visibleRule = false">返回抽奖</div>
            </div>
          </div>
          <div class="body">
            <ElScrollbar style="height: 100%;" wrapStyle="overflow-x: hidden;" viewStyle="white-space: pre-line;">
              {{ ruleText }}
            </ElScrollbar>
          </div>
        </div>
      </div>
    </ElDialog>
    <!-- 开奖记录 -->
    <ElDialog
      :visible.sync="visibleRecord"
      width="808px"
      custom-class="el-dialog-clearstyle-class custom-class-record"
      append-to-body
      @opened="onRecordOpened"
    >
      <div class="rule-record-container">
        <div class="lihui">
          <img src="@/assets/zs_imgs/cj-lihui.png" />
        </div>
        <div class="main">
          <div class="header">
            <div class="title">开奖记录</div>
            <div class="menu">
              <div class="lingjiang" @click="handleLingjiang">领取奖励</div>
              <div class="back" @click="visibleRecord = false">返回抽奖</div>
            </div>
          </div>
          <div class="body body-record">
            <input
              v-model="recordInput"
              class="user-input"
              type="text"
              placeholder="请输入您的用户昵称或用户ID"
              @input="onInput"
            />
            <div class="user-list">
              <template v-if="drawList.length > 0">
                <ElScrollbar style="height: 100%;" wrapStyle="overflow-x: hidden;">
                  <div v-for="item in drawList" :key="item.id" class="user-item">
                    <div class="user">
                      <img class="avatar" :src="formatUserAvatar(item)" referrerpolicy="no-referrer" />
                      <div class="name">
                        <div class="nike" :title="item.user.name">{{ formatUserName(item) }}</div>
                        <div class="id" :title="item.user.origin_id">{{ item.user.origin_id }}</div>
                      </div>
                    </div>
                    <div class="plat">
                      <img class="icon" :src="formatPlatImg(item.user.media_type)" />
                      <span class="name">{{ item.user.media_name }}</span>
                    </div>
                    <div class="date">{{ formatDate(item.created_at) }}</div>
                    <img class="draw" :src="formatGift(item.gift_id)" />
                  </div>
                </ElScrollbar>
              </template>
              <template v-else>
                <div class="draw-record-empty">
                  <img src="@/assets/zs_imgs/cj-reject-pic.png" />
                  <span>当前用户没有中奖哦~</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div></ElDialog
    >
    <!-- 中奖用户 -->
    <ElDialog
      :visible.sync="visibleResult"
      width="432px"
      custom-class="el-dialog-clearstyle-class custom-class-result"
      append-to-body
      @opened="onResultOpened"
    >
      <div class="draw-user-container">
        <img class="title" src="@/assets/zs_imgs/cj-user-title.png" />
        <div ref="scroll" class="user-list-scroll">
          <div class="user-list">
            <div v-for="item in drawList" :key="item.id" class="user-item">
              <div class="content">
                <div class="avatar-box">
                  <img class="avatar" :src="formatUserAvatar(item)" referrerpolicy="no-referrer" />
                  <img class="plat" :src="formatPlatImg(item.user.media_type)" />
                </div>
                <div class="nike" :title="item.user.name">{{ formatUserName(item) }}</div>
                <div class="id" :title="item.user.origin_id">ID：{{ item.user.origin_id }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="desc1">
          <div>近5分钟内以上用户获得奖励</div>
          <div>请已中奖用户添加牢鲨微信进行领奖哦~</div>
        </div>
        <div class="desc2">微信用户中奖结果已通过私信发放，请自行前往查看哦~</div>
        <div class="lingqu" @click="handleLingjiang">领取奖励</div>
      </div>
    </ElDialog>
    <!-- 未中奖 -->
    <ElDialog
      :visible.sync="visibleReject"
      width="432px"
      custom-class="el-dialog-clearstyle-class custom-class-reject"
      append-to-body
    >
      <div class="draw-reject-container">
        <img class="title" src="@/assets/zs_imgs/cj-reject-title.png" />
        <img class="pic" src="@/assets/zs_imgs/cj-reject-pic.png" />
        <div class="desc">
          <div>别灰心，平台每日还会再粉丝列表中抽取大小月卡</div>
          <div>21、22号还会抽取648现金大奖哦~</div>
        </div>
      </div>
    </ElDialog>
    <!-- 领奖二维码 -->
    <ElDialog :visible.sync="visibleQrcode" width="432px" custom-class="el-dialog-clearstyle-class" append-to-body>
      <div class="draw-reject-container">
        <div class="wechat-name">请添加牢鲨微信进行领奖哦~</div>
        <img class="pic" src="//cdnimg-v2.gamekee.com/wiki2.0/images/w_331/h_334/215/418268/2025/5/17/975433.png" />
        <div class="desc">扫一扫上面的二维码，加为好友</div>
        <div class="weixinhao">
          <div class="left">微信号</div>
          <div class="right">
            <span class="laosha">LaoSha157</span>
            <img class="copy" src="@/assets/zs_imgs/cj-qrcode-copy.png" @click="handleCopy" />
          </div>
        </div>
      </div>
    </ElDialog>
  </div>
</template>
<script>
import BScroll from "@better-scroll/core";
import dayjs from "@/plugins/dayjs";
import { apiDrawActivity, apiDrawList } from "@/api/zscaDrawApi";
import { copyToClipboard, debounce, toast } from "@/plugins/util";

export default {
  name: "ZscaChoujiang",
  props: {
    activityList: { type: Array, default: () => [] }
  },
  data() {
    return {
      /** 立即抽奖 */
      visibleDraw: false,
      /** 规则 */
      visibleRule: false,
      /** 记录 */
      visibleRecord: false,
      /** 结果 */
      visibleResult: false,
      /** 未中奖 */
      visibleReject: false,
      /** 领奖二维码 */
      visibleQrcode: false,
      recordInput: "",
      ruleText:
        "Vue (读音 /vjuː/，类似于 view) 是一套用于构建用户界面的渐进式框架。与其它大型框架不同的是，Vue 被设计为可以自底向上逐层应用。Vue 的核心库只关注视图层，不仅易于上手，还便于与第三方库或既有项目整合。另一方面，当与现代化的工具链以及各种支持类库结合使用时，Vue 也完全能够为复杂的单页应用提供驱动。如果你想在深入学习 Vue 之前对它有更多了解，我们制作了一个视频，带您了解其核心概念和一个示例工程。如果你已经是有经验的前端开发者，想知道 Vue 与其它库/框架有哪些区别，请查看对比其它框架。官方指南假设你已了解关于 HTML、CSS 和 JavaScript 的中级知识。如果你刚开始学习前端开发，将框架作为你的第一步可能不是最好的主意——掌握好基础知识再来吧！之前有其它框架的使用经验会有帮助，但这不是必需的。",
      time: "",
      wechatLink: "",
      douyinLink: "",
      bilibiliLink: "",
      drawList: []
    };
  },
  watch: {
    activityList: {
      deep: true,
      immediate: true,
      handler(array) {
        if (this.$isServer || array.length === 0) return;
        array.forEach(({ link }) => {
          if (link.includes("douyin")) {
            this.douyinLink = link;
          }
          if (link.includes("weixin")) {
            this.wechatLink = link;
          }
          if (link.includes("bilibili")) {
            this.bilibiliLink = link;
          }
        });
      }
    }
  },
  mounted() {
    this.timer = setInterval(this.updateTime, 1000);
    this.fetchRuleText();
    const end = dayjs("2025-6-23 00:00:00");
    if (dayjs().isBefore(end)) {
      this.autoShow();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    initBS() {
      if (this.bscroll) return;
      this.bscroll = new BScroll(this.$refs.scroll, {
        scrollX: true
      });
    },
    async fetchDrawList(isTimeLimit = true) {
      const end_at = dayjs()
        .unix()
        .valueOf();
      const isProd = process.env.VUE_APP_MODE === "prod";
      const count = isProd ? 5 : 500;
      const start_at = end_at - count * 60;
      const params = {
        start_at,
        end_at,
        limit: 999,
        page_no: 1,
        name: this.recordInput
      };
      if (!isTimeLimit) {
        delete params.start_at;
        delete params.end_at;
      }
      const { code, data } = await apiDrawList(params);
      if (code === 0) {
        this.drawList = data;
      }
    },
    async fetchRuleText() {
      const { code, data } = await apiDrawActivity();
      if (code === 0) {
        this.ruleText = data.desc;
      }
    },
    handleChoujiang() {
      this.visibleDraw = true;
      if (window.staticFn) {
        window.staticFn.customEvent("zs_draw_wiki_entry", { client: "pc" });
      }
    },
    async handleDraw() {
      const end = dayjs("2025-6-23 00:00:00");
      if (!dayjs().isBefore(end)) {
        toast("活动已结束");
        return;
      }

      if (window.staticFn) {
        window.staticFn.customEvent("zs_draw_launch", { client: "pc" });
      }

      const isClick = localStorage.getItem("CUSTOM_MEDIA_CLICKED");
      if (!isClick) {
        this.$message({ type: "info", message: "关注任意1个账号后，可进行1次抽奖" });
        return;
      }
      // 点击过立即抽奖，记录在本地，不自动弹出抽奖弹窗
      localStorage.setItem("CLICK_DRAW_IS_COMPLETED", Date.now() + "");
      await this.fetchDrawList();
      this.visibleDraw = false;
      if (this.drawList.length > 0) {
        this.visibleResult = true;
      } else {
        this.visibleReject = true;
      }
    },
    handleLingjiang() {
      this.visibleResult = false;
      this.visibleRecord = false;
      this.visibleQrcode = true;
    },
    async handleCopy() {
      await copyToClipboard("LaoSha157");
      this.$message({ type: "success", message: "操作成功" });
    },
    handleJumpMedia(plat) {
      localStorage.setItem("CUSTOM_MEDIA_CLICKED", "true");
      if (window.staticFn) {
        window.staticFn.customEvent(`zs_draw_${plat}`, { client: "pc" });
      }
    },
    onResultOpened() {
      setTimeout(() => {
        this.initBS();
      }, 300);
    },
    onRecordOpened() {
      this.fetchDrawList(false);
      if (window.staticFn) {
        window.staticFn.customEvent("zs_draw_record", { client: "pc" });
      }
    },
    onRuleOpened() {
      if (window.staticFn) {
        window.staticFn.customEvent("zs_draw_rule", { client: "pc" });
      }
    },
    onInput: debounce(function() {
      this.fetchDrawList(false);
    }, 300),
    autoShow() {
      // 点击过立即抽奖，则不自动显示
      const isDraw = localStorage.getItem("CLICK_DRAW_IS_COMPLETED");
      if (isDraw) return;

      const key = "ZSCA_EVERY_DAY_FIRST_DRAW";
      const time = localStorage.getItem(key) || dayjs(1970, 1, 1).valueOf();

      // 不是同一天则显示提示
      if (!dayjs().isSame(dayjs(Number(time)), "day")) {
        localStorage.setItem(key, Date.now());
        this.visibleDraw = true;
        if (window.staticFn) {
          window.staticFn.customEvent("zs_draw_dialog", { client: "pc" });
        }
      }
    },
    updateTime() {
      const end = dayjs("2025-6-23 00:00:00");
      const diffsecond = end.diff(dayjs(), "second");
      if (diffsecond <= 0) {
        this.time = "已结束";
        clearInterval(this.timer);
        return;
      }
      this.time = dayjs.duration(diffsecond, "second").format("还剩：D天H小时m分钟s秒");
    },
    formatDate(value) {
      return dayjs.unix(value).format("M月D日");
    },
    formatPlatImg(value) {
      if (value === 1) return require("@/assets/zs_imgs/cj-plat-bilibili.png");
      if (value === 2) return require("@/assets/zs_imgs/cj-plat-wechat.png");
      if (value === 3) return require("@/assets/zs_imgs/cj-plat-douyin.png");
    },
    formatGift(value) {
      if (value === 1) return require("@/assets/zs_imgs/cj-10.png");
      if (value === 2) return require("@/assets/zs_imgs/cj-card.png");
      if (value === 3) return require("@/assets/zs_imgs/cj-648.png");
    },
    formatUserName(object) {
      if (object.user.media_type === 1) {
        return object.user.name || "B站用户";
      }
      if (object.user.media_type === 2) {
        return object.user.name || "微信用户";
      }
      if (object.user.media_type === 3) {
        return object.user.name || "抖音用户";
      }
    },
    formatUserAvatar(object) {
      return object.user.avatar || require("@/assets/zs_imgs/cj-default-avatar.png");
    }
  }
};
</script>
<style lang="less" scoped>
.zsca-choujiang {
  position: relative;
  top: 12px;
  .button {
    width: 69px;
    height: 90px;
    background: url("~@/assets/zs_imgs/cj-aside-entry.png") center/cover no-repeat;
  }
}
.rule-record-container {
  background: url("~@/assets/zs_imgs/cj-bg.png") center / 808px 440px no-repeat;
  display: flex;
  height: 440px;
  .lihui {
    width: 40%;
    position: relative;
    img {
      position: absolute;
      right: 0;
      bottom: 0;
      object-fit: contain;
      width: 427px;
      height: 487px;
    }
  }
  .main {
    width: 60%;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    padding: 20px 26px 20px 0;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        color: #383838;
        font-size: 18px;
        font-weight: bold;
      }
      .menu {
        display: flex;
        align-items: center;
        column-gap: 30px;
        font-size: 13px;
        /* 领取奖励 */
        .lingjiang {
          color: #ff6a00;
          text-decoration-line: underline;
          cursor: pointer;
        }
        /* 返回 */
        .back {
          cursor: pointer;
          position: relative;
          width: 94px;
          height: 24px;
          display: flex;
          align-items: center;
          border-radius: 24px;
          color: #fff3ed;
          background-color: rgba(62, 33, 20, 0.4);
          padding-left: 30px;
          &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 14px;
            transform: translateY(-50%) rotate(-45deg);
            width: 8px;
            height: 8px;
            border-top: 1px solid #fff3ed;
            border-left: 1px solid #fff3ed;
          }
        }
        /* 中奖名单 */
        .jiangbei {
          display: flex;
          align-items: center;
          width: 94px;
          height: 24px;
          border-radius: 24px;
          color: #fff3ed;
          font-size: 13px;
          background: url("~@/assets/zs_imgs/cj-draw-jiangbei.png") right 4px center / 20px 20px no-repeat
            rgba(62, 33, 20, 0.4);
          padding-left: 10px;
          cursor: pointer;
        }
        /* 抽奖规则 */
        .rule {
          display: flex;
          align-items: center;
          width: 94px;
          height: 24px;
          border-radius: 24px;
          color: #fff3ed;
          font-size: 13px;
          background: url("~@/assets/zs_imgs/cj-draw-rule.png") right 4px center / 20px 20px no-repeat
            rgba(62, 33, 20, 0.4);
          padding-left: 10px;
          cursor: pointer;
        }
      }
    }
    .body {
      flex-grow: 1;
      background-color: rgba(255, 255, 255, 0.46);
      border-radius: 14px;
      padding: 18px;
      color: #666666;
    }
  }
}
/* 开奖记录 */
.body-record {
  display: flex;
  flex-direction: column;
  .user-input {
    display: block;
    width: 100%;
    border: 1px solid #ebe9e1;
    border-radius: 8px;
    background: #ffffff;
    line-height: 36px;
    outline: none;
    color: #977961;
    font-size: 13px;
    padding: 0 10px;
  }
  .user-list {
    flex-grow: 1;
    height: 0;
    .user-item {
      display: flex;
      align-items: center;
      box-sizing: content-box;
      justify-content: space-between;
      padding: 14px 0;
      border-bottom: 1px solid rgba(123, 58, 21, 0.1);
      &:last-child {
        border-bottom: unset;
      }
      .user {
        display: flex;
        align-items: center;
        column-gap: 2px;
        .avatar {
          width: 28px;
          height: 28px;
          border-radius: 50%;
        }
        .name {
          display: flex;
          flex-direction: column;
          row-gap: 4px;
          width: 70px;
          white-space: nowrap;
          overflow: hidden;
          .nike {
            color: #333333;
            font-size: 12px;
            font-weight: bold;
            max-width: 70px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .id {
            color: #666666;
            font-size: 10px;
            max-width: 70px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .plat {
        display: flex;
        align-items: center;
        column-gap: 6px;
        .icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
        .name {
          color: #333333;
          font-size: 12px;
          width: 30px;
        }
      }
      .date {
        color: #333333;
        font-size: 12px;
      }
      .draw {
        width: 85px;
        height: 24px;
      }
    }
    .draw-record-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      row-gap: 15px;
      margin-top: 50px;
      img {
        width: 135px;
      }
      span {
        color: #525c6c;
        font-size: 13px;
      }
    }
  }
}
/* 立即抽奖 */
.rule-record-container .main {
  position: relative;
  .body-draw {
    background-color: transparent;
    padding: 0;
    .title {
      color: #7d2a19;
      font-weight: bold;
      display: flex;
      align-items: flex-end;
      white-space: nowrap;
      .toyou {
        font-size: 38px;
        background: linear-gradient(to bottom, #c2361a, #5e2317);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      .wiki {
        font-size: 30px;
        background: linear-gradient(to bottom, #c2361a, #5e2317);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }
    .time {
      margin-top: 10px;
      color: #a65442;
      font-size: 13px;
    }
    .fuli {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
      .new,
      .old {
        background-image: linear-gradient(to top, #ffe6c1, #fff1c9);
        border-radius: 12px;
        padding: 1px;
        .inner {
          height: 100%;
          background-image: linear-gradient(to bottom, #a1642d, #db9760);
          padding: 10px 14px 8px 14px;
          border-radius: 10px;
          .name {
            color: #ffffff;
            font-size: 15px;
          }
          .desc {
            color: #ebe6d5;
            font-size: 13px;
            margin-top: 4px;
          }
          .container {
            display: flex;
            margin-top: 8px;
            .item {
              width: 108px;
              padding: 2px;
              border-radius: 12px;
              background-image: linear-gradient(to bottom, #db9558, #f7c295);
              .item-inner {
                display: flex;
                flex-direction: column;
                align-items: center;
                row-gap: 6px;
                background-color: rgba(0, 0, 0, 0.33);
                border-radius: 10px;
                box-sizing: content-box;
                padding-top: 12px;
                padding-bottom: 6px;
                .txt {
                  color: #f7e1a8;
                  font-size: 12px;
                }
                .icon {
                  width: 88px;
                  height: 88px;
                }
              }
            }
          }
        }
      }
      .new {
        width: 33%;
        .inner {
          .container {
            justify-content: center;
          }
        }
      }
      .old {
        width: 58%;
        .inner {
          .container {
            justify-content: space-between;
          }
        }
      }
    }
    .line {
      height: 1px;
      background-color: #866153;
      margin: 16px 0 24px;
    }
    .fllow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #4d2a22;
      font-size: 13px;
      font-weight: bold;
      padding-right: 26px;
      .plat {
        position: relative;
        padding: 0 14px;
        line-height: 22px;
        border-radius: 22px;
        color: #fff;
        font-size: 12px;
        font-weight: bold;
        background-color: #c03229;
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: -26px;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
      .douyin::after {
        background-image: url("~@/assets/zs_imgs/cj-draw-douyin.png");
      }
      .wechat::after {
        background-image: url("~@/assets/zs_imgs/cj-draw-wechat.png");
      }
      .bilibili::after {
        background-image: url("~@/assets/zs_imgs/cj-draw-bilibili.png");
      }
    }
  }
  /* 立即抽奖按钮 */
  .draw-button {
    position: absolute;
    right: 0;
    bottom: -62px;
    width: 251px;
    line-height: 48px;
    background: linear-gradient(0deg, #ffd78b 0%, #ffb81e 100%);
    border-radius: 12px;
    font-weight: 800;
    font-size: 20px;
    color: #543305;
    text-align: center;
    cursor: pointer;
  }
  .draw-button-disable {
    color: #3f3f3f;
    background: unset;
    background-color: #e0e0e0;
  }
}
/* 中奖用户 */
.draw-user-container {
  width: 432px;
  background-image: linear-gradient(to bottom, #ffe7b8, #ffffff);
  border-radius: 20px;
  padding: 20px 0;
  .title {
    height: 36px;
    width: fit-content;
    display: block;
    margin: auto;
  }
  .user-list-scroll {
    margin: 0 28px;
    padding-top: 44px;
    overflow-x: hidden;
    .user-list {
      display: flex;
      justify-content: center;
      column-gap: 20px;
      width: fit-content;
      min-width: 100%;
      .user-item {
        width: 110px;
        height: 118px;
        background: linear-gradient(to bottom, #ffd186, #ffd186);
        border-radius: 16px;
        .content {
          position: relative;
          top: -28px;
          .avatar-box {
            position: relative;
            width: 72px;
            height: 72px;
            margin: auto;
            .avatar {
              position: absolute;
              width: 100%;
              height: 100%;
              border: 2px solid #fff;
              border-radius: 50%;
            }
            .plat {
              position: absolute;
              left: 50%;
              width: 22px;
              height: 22px;
              transform: translateX(-50%);
              bottom: -10px;
            }
          }
          .nike {
            color: #7e5400;
            font-size: 14px;
            font-weight: bold;
            width: fit-content;
            margin: 24px auto 0;
            max-width: 80px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .id {
            color: #8b671d;
            font-size: 12px;
            width: fit-content;
            margin: auto;
            max-width: 80px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .desc1 {
    width: fit-content;
    margin: 32px auto 16px;
    color: #c16100;
    font-size: 13px;
    text-align: center;
  }
  .desc2 {
    width: fit-content;
    margin: 0 auto;
    color: #817263;
    font-size: 12px;
  }
  .lingqu {
    width: 384px;
    line-height: 44px;
    background: linear-gradient(to bottom, #ffd8b0, #ffb81e);
    box-shadow: 0px 0px 4px 0px rgba(189, 131, 9, 0.65);
    border-radius: 22px;
    text-align: center;
    margin: 14px auto 0;
    color: #7e5400;
    font-size: 16px;
    font-weight: bold;
  }
}
/* 未中奖/加好友 */
.draw-reject-container {
  background-image: linear-gradient(to bottom, #e4fbff, #fff);
  border-radius: 20px;
  padding: 22px 0 26px;
  .wechat-name {
    color: #536972;
    font-size: 20px;
    font-weight: bold;
    width: fit-content;
    margin: auto;
  }
  .title {
    height: 27px;
    display: block;
    width: fit-content;
    margin: auto;
  }
  .pic {
    width: 121px;
    display: block;
    margin: 26px auto;
  }
  .desc {
    color: #525c6c;
    font-size: 13px;
    width: fit-content;
    text-align: center;
    margin: auto;
  }
  .weixinhao {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    margin: 20px auto;
    .left {
      color: #536a73;
      font-size: 16px;
    }
    .right {
      display: flex;
      align-items: center;
      column-gap: 4px;
      .laosha {
        color: #536a73;
        font-size: 14px;
      }
      .copy {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
  }
}
/deep/ .custom-class-rule .rule-record-container .main .body {
  height: 0;
}
</style>
